import * as React from "react";
import CardsManager, {
	CardsManagerCallbacks,
} from "../CardsManager/CardsManager";
import BookCalendar from "./BookCalendar";
import { useParams, useHistory } from "react-router-dom";

interface Props {
	section?: string;
	callbacks?: CardsManagerCallbacks;
}

const BookCalendarWrapper: React.FC<Props> = (props) => {
	const params = useParams<{ id?: string }>();
	const history = useHistory();

	const setCardId = (cardId: number) => {
		if (cardId < 0) {
			history.goBack();
		} else {
			history.push(`/${cardId}`);
		}
	};

	return (
		<BookCalendar
			callbacks={props.callbacks}
			cardId={params.id}
			defaultSection={props.section}
			setCardId={setCardId}
			loading={props.callbacks.loading}
		/>
	);
};

export default BookCalendarWrapper;
